import loginLayoutComponent from "./plugins/loginLayoutComponent"
import searchComponentPlugin from "./plugins/searchComponentPlugin"
import loginEngineComponentPlugin from "./plugins/loginEngineComponentPlugin"
import appNavPlugin from "./plugins/appNavPlugin"
import routerNavPlugin from "./plugins/routerNavPlugin"
import useSubPageAppIdPlugin from "./plugins/useSubPageAppIdPlugin"
import chartEventController from "./plugins/chartEventController"
import diffTabPlugin from "./plugins/diffTabPlugin"
import ListPageSearchComponentPlugin from "./plugins/ListPageSearchComponentPlugin"
// import listPageComponentPlugin from "./plugins/listPageComponentPlugin" // 用于老数据兼容使用

export default {
  mixins: [
    diffTabPlugin,
    loginLayoutComponent,
    searchComponentPlugin,
    loginEngineComponentPlugin,
    appNavPlugin,
    routerNavPlugin,
    useSubPageAppIdPlugin,
    chartEventController,
    ListPageSearchComponentPlugin
  ]
}
